<template>
  <transition name="zoom">
    <div class="contextmenu"
      v-show="isShow"
      @mouseleave.self="isShow=false"
      :style="{top:top,left:left}">
      <ul>
        <li
          v-for="(item,index) in menuOptions.menulist"
          :key="index"
          @click="clickMenuHandle(item)" @contextmenu.prevent="">{{item.label}}</li>
      </ul>
    </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      menuOptions: {},
      isShow: false,
      left: 0,
      top: 0
    }
  },
  methods: {
    openMenu (options, e) { // options 菜单参数, e 鼠标右键事件
      this.menuOptions = options
      this.isShow = true

      this.top = e.pageY - 20 + 'px'
      this.left = e.pageX - 20 + 'px'
      e.preventDefault()
    },
    clickMenuHandle (item) {
      this.menuOptions.callback(this.menuOptions.data, item.type)
      this.isShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.zoom-enter-active, .zoom-leave-active {
  transition: opacity .3s,transform .3s;
}
.zoom-enter, .zoom-leave-to {
  opacity: 0;
  transform: scale(0.5,0.5)
}
.contextmenu {
  width: 180px;
  padding: 10px 0;
  position: fixed;
  cursor: pointer;
  box-shadow: 1px 2px 2px 1px #bbbbbb;
  background-color: #ffffff;
  z-index: 1000;

  li {
    height: 35px;
    line-height: 35px;
    color: #333333;
    text-indent: 20px;
    font-size: 14px;

    &:hover {
      background-color: #3c8dbc;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContextMenu/ContextMenu.vue